// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesListGroup-moduledivider__BKDxI Divider-moduleDivider__dL3Vg";
var _2 = "EntityProfileTabUpdatesListGroup-modulegroup__vEkdz";
var _3 = "EntityProfileTabUpdatesListGroup-moduleheading__iu6kU";
var _4 = "EntityProfileTabUpdatesListGroup-moduleitems__uTksg";
var _5 = "EntityProfileTabUpdatesListGroup-moduletitle__Jloap";
export { _1 as "divider", _2 as "group", _3 as "heading", _4 as "items", _5 as "title" }
